import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	DxConnectorPieChart,
	DxLabelPieChart,
	DxLegendPieChart,
	DxPieChart,
	DxSeriesPieChart
} from '../../../components/common/DxCharts';
import { rootApi } from '../../../context/api/rootApi';
import { BaseResponse } from '../../../context/base/BaseResponse';
import { AppState } from '../../../context/stores/rootReducers';
import { createUUID } from '../../../utils/createUUID';
import { NoDataLoading } from '../../../components/base/NoDataLoading';

interface BaoCaoHocSinhTheoKhoiResponse {
	dm_truong_id: number;
	dm_khoi_id: number;
	dm_he_id: number;
	ten_truong: string;
	ten_truong_en: string;
	ten_khoi: string;
	ten_khoi_en: string;
	ten_he: string;
	ten_he_en: string;
	hocsinh_total: number;
}

const customizeText = (arg: any) => {
	return `${arg.valueText} (${arg.percentText})`;
};
const BaoCaoHocSinhTheoHePieChart = () => {
	const [dataReport, setDataReport] = useState<BaoCaoHocSinhTheoKhoiResponse[]>([]);
	const { dm_coso_id, dm_truong_id, nam_hoc, hoc_ky } = useSelector((state: AppState) => state.common);
	const handleReloadData = useCallback(async () => {
		const res: BaseResponse = await rootApi.baoCao.SelectChartHocSinhTheoHeAsync(dm_coso_id, dm_truong_id, nam_hoc, hoc_ky);
		if (res.isSuccess && res.result) {
			const listCategory = res.result as BaoCaoHocSinhTheoKhoiResponse[];
			setDataReport(listCategory);
		} else {
			setDataReport([]);
		}
	}, [dm_coso_id, dm_truong_id, nam_hoc, hoc_ky]);

	useEffect(() => {
		handleReloadData();
	}, [dm_coso_id, dm_truong_id, nam_hoc]);
	const khoiGrouped = useMemo(() => {
		const huyenGrouped = dataReport.reduce((khoiGroupData: any[], source) => {
			const exited = khoiGroupData.find((x: any) => x.ten_he === source.ten_he);
			if (!exited) {
				source = {
					...source,
					hocsinh_total: dataReport.filter(x => x.dm_he_id === source.dm_he_id).reduce(function (prev, current) {
						return prev + +current.hocsinh_total
					}, 0)
				}
				khoiGroupData.push(source);
			}
			return khoiGroupData; ``
		}, []);
		return huyenGrouped;
	}, [dataReport]);

	return (
		<>
			{(!khoiGrouped || khoiGrouped.length === 0) && <NoDataLoading />}
			{khoiGrouped && khoiGrouped.length > 0 &&
				<DxPieChart
					id={createUUID()}
					palette={['#1E8FF5', '#26CECB', '#8037ED', '#001859', '#A6F6FF']}
					dataSource={khoiGrouped}
					resolveLabelOverlapping={'shift'}
					className='w-100'
					height={400}
				>
					<DxLegendPieChart
						orientation='horizontal'
						itemTextPosition='right'
						horizontalAlignment='center'
						verticalAlignment='bottom'
						columnCount={4}
					/>
					<DxSeriesPieChart argumentField='ten_he' valueField='hocsinh_total'>
						<DxLabelPieChart visible={true} position='columns' customizeText={customizeText}>
							<DxConnectorPieChart visible={true} width={0.5} />
						</DxLabelPieChart>
					</DxSeriesPieChart>
				</DxPieChart>
			}
		</>
	);
};

export default BaoCaoHocSinhTheoHePieChart;
